<template>
  <div class="content-wrapper buyticket">
    <!-- チケットストア帯ヘッダー -->
    <TheStoreHeader page="2" :is0yenTicket="is0yenTicket" />

    <!-- メインコンテンツ -->
    <div class="form">
      <!-- 購入内容確認の上部表示 購入内容テーブル -->
      <TheBBCUpper />

      <hr />

      <!-- 購入内容確認の下部表示 ■ ご注意 ■ など-->
      <TheBBCLower />

      <!-- アクションボタン -->
      <TheBBCActions :is0yenTicket="is0yenTicket" />
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";

export default {
  name: "TemplateBookBookingConfirmation",
  setup() {
    const route = useRoute();
    const is0yenTicket = route.query.is_0yen_ticket == "true" ? true : false;
    return {
      is0yenTicket,
    };
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin: 20px 15px;
}
</style>
